<template lang="pug">
  div.size(:class="{alert : alert}")
    div.tit {{ itm.tit }}
    input(type="number",:value="valu",@change="change",@keyup="change",@blur="blur")
    div.mm mm
</template>

<script>
export default{
  name: 'InputSize',
  data () {
    return {
    };
  },
  props: {
    itm: Object,
    tit: String,
    val: Number
  },
  computed: {
    valu () {
      return this.itm.val;
    },
    alert () {
      return this.itm.alert;
    },
    id () {
      return this.itm.id;
    }
  },
  watch: {
    valu (i, s) {
    }
  },
  methods: {
    change (e) {
      let num = parseInt(e.target.value);
      if (!isNaN(num)) {
        e.target.value = num;
        this.$emit('change', num);
      }
    },
    blur (e) {
      let num = parseInt(e.target.value);
      if (!isNaN(num)) {
        e.target.value = num;
        this.$emit('blur', this.id, num);
      }
    }
  },
  created () {
  }
};
</script>

<style lang="stylus" scoped>
  .size
    display flex
    font-size 12px
    align-items center
    font-weight bold
    margin-right 20px
    &:last-child
      margin-right 0
    .tit
      margin-right 5px
      color #666666
      user-select none
    .mm
      margin-left 5px
      color #666666
      user-select none
    input
      width 70px
      height 33px
      border-radius 2px
      border 1px solid #dddddd
      text-align right
      padding 5px
      font-weight bold
      font-size 16px
    &.alert
      input
        border 1px solid #cc0000
        color #cc0000
      /*.tit
        color #cc0000
      .mm
        color #cc0000*/

</style>



// WEBPACK FOOTER //
// src/components/header/InputSize.vue